export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8646.62d70899.jpg";